// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.csu-credits-page {
  --csu-bg: #ffffff;
  --csu-surface: #ffffff;
  --csu-surface-2: #f7f8fa;
  --csu-text: #111827;
  --csu-muted: #4b5563;
  --csu-line: #e5e7eb;
  --csu-accent: #2563eb;
  --csu-accent-2: #0f766e;
  color: var(--csu-text);
  background: var(--csu-bg);
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", Arial, sans-serif;
  line-height: 1.7;
}

.csu-credits-page * {
  box-sizing: border-box;
}

.csu-credits-page a {
  color: var(--csu-accent);
  text-decoration: none;
}

.csu-credits-page a:hover {
  text-decoration: underline;
}

.csu-credits-page p {
  margin: 0 0 12px;
  color: var(--csu-muted);
}

.csu-credits-page h1, .csu-credits-page h2, .csu-credits-page h3 {
  margin: 0 0 12px;
  line-height: 1.25;
  color: var(--csu-text);
}

.csu-credits-page h1 {
  font-size: 28px;
  letter-spacing: 0.2px;
}

.csu-credits-page h2 {
  font-size: 20px;
  margin-top: 8px;
}

.csu-credits-page h3 {
  font-size: 16px;
  margin-top: 2px;
}

.csu-credits-page .container {
  max-width: 1080px;
  margin: 0 auto;
  padding: 28px 16px 56px;
}

.csu-credits-page .hero {
  border: 1px solid var(--csu-line);
  border-radius: 18px;
  padding: 22px 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 10px 26px rgba(17, 24, 39, 0.06);
}

/* Top image */
.csu-credits-page .hero-media {
  border: 1px solid var(--csu-line);
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);
  margin-bottom: 16px;
}

.csu-credits-page .hero-media img {
  display: block;
  width: 100%;
  height: auto;
}

.csu-credits-page .hero-top {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 14px;
  align-items: start;
}

.csu-credits-page .subheadline {
  margin: 6px 0 0;
  color: var(--csu-text);
  font-weight: 650;
  letter-spacing: 0.2px;
}

.csu-credits-page .tagline {
  margin: 6px 0 0;
  color: var(--csu-muted);
  font-size: 14px;
}

.csu-credits-page .badge-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0;
}

.csu-credits-page .badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid var(--csu-line);
  background: #ffffff;
  color: var(--csu-muted);
  font-size: 12.5px;
  white-space: nowrap;
}

.csu-credits-page .badge strong {
  color: var(--csu-text);
  font-weight: 650;
}

.csu-credits-page .hero-side {
  border: 1px solid var(--csu-line);
  border-radius: 14px;
  padding: 14px 14px 12px;
  background: var(--csu-surface-2);
}

.csu-credits-page .meta {
  display: grid;
  gap: 10px;
  margin-top: 6px;
}

.csu-credits-page .meta-item {
  display: grid;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--csu-line);
  background: #ffffff;
}

.csu-credits-page .meta-label {
  font-size: 12px;
  color: var(--csu-muted);
}

.csu-credits-page .meta-value {
  font-size: 14px;
  color: var(--csu-text);
  font-weight: 650;
}

.csu-credits-page .grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-top: 14px;
}

.csu-credits-page .section {
  border: 1px solid var(--csu-line);
  border-radius: 16px;
  background: #ffffff;
  padding: 18px 16px;
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);
}

.csu-credits-page .section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.csu-credits-page .section-head .hint {
  font-size: 12.5px;
  color: var(--csu-muted);
  border: 1px dashed #d1d5db;
  padding: 6px 10px;
  border-radius: 10px;
  background: #fafafa;
}

.csu-credits-page .divider {
  height: 1px;
  background: var(--csu-line);
  margin: 16px 0;
}

.csu-credits-page .table-wrap {
  border: 1px solid var(--csu-line);
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
}

.csu-credits-page table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.csu-credits-page thead th {
  text-align: left;
  padding: 12px 12px;
  background: #f9fafb;
  border-bottom: 1px solid var(--csu-line);
  color: var(--csu-text);
  font-weight: 650;
  vertical-align: bottom;
}

.csu-credits-page tbody td {
  padding: 12px 12px;
  border-bottom: 1px solid var(--csu-line);
  color: var(--csu-muted);
  vertical-align: top;
}

.csu-credits-page tbody tr:last-child td {
  border-bottom: none;
}

.csu-credits-page .pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  white-space: nowrap;
}

/* =========================
   各科課表：逐列呈現
   ========================= */
.csu-credits-page .schedule-list {
  display: grid;
  gap: 10px;
  margin-top: 10px;
}

.csu-credits-page .schedule-row {
  border: 1px solid var(--csu-line);
  border-radius: 14px;
  background: #ffffff;
  padding: 12px 12px;
}

.csu-credits-page .schedule-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

/* Slightly more space between course code pill and the English course name */
.csu-credits-page .schedule-head .pill {
  margin-bottom: 8px;
}

.csu-credits-page .schedule-title {
  margin: 0;
  font-size: 15px;
  color: var(--csu-text);
  font-weight: 750;
  line-height: 1.25;
}

.csu-credits-page .nowrap {
  white-space: nowrap;
}

.csu-credits-page .kv {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 10px;
  padding: 7px 0;
  border-top: 1px solid var(--csu-line);
}

.csu-credits-page .kv:first-of-type {
  border-top: none;
  padding-top: 0;
}

.csu-credits-page .k {
  color: #6b7280;
  font-size: 12px;
  margin: 0;
}

.csu-credits-page .v {
  color: var(--csu-text);
  font-size: 13px;
  margin: 0;
}

.csu-credits-page .scope-list {
  margin: 6px 0 0;
  padding-left: 18px;
  color: var(--csu-muted);
  font-size: 13px;
}

.csu-credits-page .scope-list li {
  margin: 6px 0;
}

/* =========================
   教學範圍：字級/層級更和諧（不動內容）
   ========================= */
.csu-credits-page .teaching-scope {
  font-size: 12.5px;
  line-height: 1.75;
  color: var(--csu-muted);
}

.csu-credits-page .teaching-scope p {
  margin: 0 0 6px;
  color: inherit;
}

.csu-credits-page .teaching-scope p:nth-child(odd) {
  color: #374151;
}

.csu-credits-page .teaching-scope p:nth-child(even) {
  color: #4b5563;
}

.csu-credits-page .teaching-scope p:nth-child(3) {
  margin-top: 8px;
}

.csu-credits-page .teaching-scope p:nth-child(5) {
  margin-top: 8px;
}

.csu-credits-page .teaching-scope p:last-child {
  margin-bottom: 0;
}

/* =========================
   評量方式 / 期末考試 / 選課身份 / 學分費用：直接顯示（不需點開）
   ========================= */
.csu-credits-page .info-grid--four {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 10px;
}

.csu-credits-page .info-box {
  border: 1px solid var(--csu-line);
  border-radius: 14px;
  background: #ffffff;
  padding: 12px 12px;
}

.csu-credits-page .info-box h3 {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 750;
  color: var(--csu-text);
}

.csu-credits-page .mini {
  font-size: 12.5px;
  color: #6b7280;
  margin: 0;
}

.csu-credits-page .bullets {
  margin: 8px 0 0;
  padding-left: 18px;
  color: var(--csu-muted);
  font-size: 13px;
}

.csu-credits-page .bullets li {
  margin: 6px 0;
}

.csu-credits-page .badge-strong {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #ccfbf1;
  background: #f0fdfa;
  color: var(--csu-accent-2);
  font-size: 12px;
  white-space: nowrap;
  margin-left: 8px;
}

/* =========================
   Call To Action (placed at the end)
   ========================= */
.csu-credits-page .cta {
  border: 1px solid var(--csu-line);
  border-radius: 16px;
  background: #f9fafb;
  padding: 16px 14px;
}

.csu-credits-page .cta-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.csu-credits-page .cta-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--csu-text);
  line-height: 1.2;
}

.csu-credits-page .cta-sub {
  margin: 0;
  color: var(--csu-muted);
  font-size: 13px;
}

.csu-credits-page .cta-sub a {
  color: var(--csu-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.csu-credits-page .cta-sub a:hover {
  color: #1d4ed8;
  text-decoration-thickness: 2px;
}

.csu-credits-page .cta-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 10px;
}

.csu-credits-page .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 12px;
  border-radius: 14px;
  border: 1px solid var(--csu-line);
  background: #ffffff;
  color: var(--csu-text);
  font-weight: 800;
  font-size: 14px;
  text-decoration: none;
  transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;
}

.csu-credits-page .btn:hover {
  text-decoration: none;
  transform: translateY(-1px);
  background: #f9fafb;
  border-color: #d1d5db;
}

.csu-credits-page .btn-primary {
  background: var(--csu-accent);
  border-color: var(--csu-accent);
  color: #ffffff;
}

.csu-credits-page .btn-primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.csu-credits-page .btn-secondary {
  background: #ffffff;
  border-color: #c7d2fe;
  color: #1e3a8a;
}

.csu-credits-page .btn-secondary:hover {
  background: #eef2ff;
  border-color: #a5b4fc;
}

.csu-credits-page .btn-note {
  margin-top: 10px;
  font-size: 12.5px;
  color: #6b7280;
  line-height: 1.6;
}

/* =========================
   RWD
   ========================= */
@media (max-width: 920px) {
  .csu-credits-page .hero-top {
    grid-template-columns: 1fr;
  }
  .csu-credits-page .section-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .csu-credits-page h1 {
    font-size: 24px;
  }
  .csu-credits-page .kv {
    grid-template-columns: 1fr;
  }
  .csu-credits-page .info-grid--four {
    grid-template-columns: 1fr;
  }
  .csu-credits-page .cta-actions {
    grid-template-columns: 1fr;
  }
  .csu-credits-page .schedule-head .pill {
    margin-bottom: 10px;
  }
}
@media (max-width: 520px) {
  .csu-credits-page .container {
    padding: 18px 12px 44px;
  }
  .csu-credits-page .hero {
    padding: 18px 14px;
  }
  .csu-credits-page .section {
    padding: 16px 14px;
  }
  .csu-credits-page table {
    font-size: 13px;
  }
  .csu-credits-page thead th, .csu-credits-page tbody td {
    padding: 10px 10px;
  }
  .csu-credits-page .badge {
    font-size: 12px;
  }
  .csu-credits-page .teaching-scope {
    font-size: 12.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/csu/styles/csu.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACM,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,yBAAA;EACA,gJAAA;EAEA,gBAAA;AAAN;;AAGI;EAAsB,sBAAA;AAC1B;;AAAI;EAAsB,wBAAA;EAA0B,qBAAA;AAKpD;;AAJI;EAA4B,0BAAA;AAQhC;;AAPI;EAAsB,gBAAA;EAAkB,uBAAA;AAY5C;;AAXI;EAAmE,gBAAA;EAAkB,iBAAA;EAAmB,sBAAA;AAiB5G;;AAhBI;EAAuB,eAAA;EAAiB,qBAAA;AAqB5C;;AApBI;EAAuB,eAAA;EAAiB,eAAA;AAyB5C;;AAxBI;EAAuB,eAAA;EAAiB,eAAA;AA6B5C;;AA3BI;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;AA8BN;;AA3BI;EACE,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,8CAAA;AA8BN;;AA3BI,cAAA;AACA;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;AA8BN;;AA3BI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA8BN;;AA3BI;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,kBAAA;AA8BN;;AA3BI;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AA8BN;;AA3BI;EACE,eAAA;EACA,uBAAA;EACA,eAAA;AA8BN;;AA3BI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AA8BN;;AA3BI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,iCAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AA8BN;;AA3BI;EAAkC,sBAAA;EAAwB,gBAAA;AAgC9D;;AA9BI;EACE,iCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAiCN;;AA9BI;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAiCN;;AA9BI;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;AAiCN;;AA9BI;EAAgC,eAAA;EAAiB,uBAAA;AAmCrD;;AAlCI;EAAgC,eAAA;EAAiB,sBAAA;EAAwB,gBAAA;AAwC7E;;AAtCI;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAyCN;;AAtCI;EACE,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;AAyCN;;AAtCI;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAyCN;;AAtCI;EACE,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAyCN;;AAtCI;EACE,WAAA;EACA,2BAAA;EACA,cAAA;AAyCN;;AAtCI;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAyCN;;AAtCI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAyCN;;AAtCI;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAyCN;;AAtCI;EACE,kBAAA;EACA,wCAAA;EACA,uBAAA;EACA,mBAAA;AAyCN;;AAtCI;EAA2C,mBAAA;AA0C/C;;AAxCI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AA2CN;;AAxCI;;8BAAA;AAGA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AA2CN;;AAxCI;EACE,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA2CN;;AAxCI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AA2CN;;AAxCI,6EAAA;AACA;EAAyC,kBAAA;AA4C7C;;AA1CI;EACE,SAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AA6CN;;AA1CI;EAA4B,mBAAA;AA8ChC;;AA5CI;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;AA+CN;;AA5CI;EAAsC,gBAAA;EAAkB,cAAA;AAiD5D;;AAhDI;EAAuB,cAAA;EAAgB,eAAA;EAAiB,SAAA;AAsD5D;;AArDI;EAAuB,sBAAA;EAAwB,eAAA;EAAiB,SAAA;AA2DpE;;AAzDI;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AA4DN;;AA1DI;EAAmC,aAAA;AA8DvC;;AA5DI;;8BAAA;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,uBAAA;AA+DN;;AA5DI;EACE,eAAA;EACA,cAAA;AA+DN;;AA5DI;EAAqD,cAAA;AAgEzD;;AA/DI;EAAsD,cAAA;AAmE1D;;AAlEI;EAAmD,eAAA;AAsEvD;;AArEI;EAAmD,eAAA;AAyEvD;;AAxEI;EAAiD,gBAAA;AA4ErD;;AA1EI;;8BAAA;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AA6EN;;AA1EI;EACE,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA6EN;;AA1EI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA6EN;;AA1EI;EACE,iBAAA;EACA,cAAA;EACA,SAAA;AA6EN;;AA1EI;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AA6EN;;AA3EI;EAAgC,aAAA;AA+EpC;;AA7EI;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAgFN;;AA7EI;;8BAAA;AAGA;EACE,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAgFN;;AA7EI;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAgFN;;AA7EI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAgFN;;AA7EI;EACE,SAAA;EACA,uBAAA;EACA,eAAA;AAgFN;;AA7EI;EACE,wBAAA;EACA,0BAAA;EACA,0BAAA;AAgFN;;AA7EI;EACE,cAAA;EACA,8BAAA;AAgFN;;AA7EI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAgFN;;AA7EI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,gFAAA;AAgFN;;AA7EI;EACE,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;AAgFN;;AA7EI;EACE,6BAAA;EACA,+BAAA;EACA,cAAA;AAgFN;;AA7EI;EACE,mBAAA;EACA,qBAAA;AAgFN;;AA7EI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAgFN;;AA7EI;EACE,mBAAA;EACA,qBAAA;AAgFN;;AA7EI;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAgFN;;AA7EI;;8BAAA;AAGA;EACE;IAA8B,0BAAA;EAiFlC;EAhFI;IAAkC,sBAAA;IAAwB,uBAAA;EAoF9D;EAnFI;IAAuB,eAAA;EAsF3B;EArFI;IAAwB,0BAAA;EAwF5B;EAvFI;IAAqC,0BAAA;EA0FzC;EAzFI;IAAiC,0BAAA;EA4FrC;EA3FI;IAAyC,mBAAA;EA8F7C;AACF;AA5FI;EACE;IAA+B,uBAAA;EA+FnC;EA9FI;IAA0B,kBAAA;EAiG9B;EAhGI;IAA6B,kBAAA;EAmGjC;EAlGI;IAA0B,eAAA;EAqG9B;EApGI;IAAyD,kBAAA;EAuG7D;EAtGI;IAA2B,eAAA;EAyG/B;EAxGI;IAAoC,iBAAA;EA2GxC;AACF","sourcesContent":[".csu-credits-page {\r\n      --csu-bg: #ffffff;\r\n      --csu-surface: #ffffff;\r\n      --csu-surface-2: #f7f8fa;\r\n      --csu-text: #111827;\r\n      --csu-muted: #4b5563;\r\n      --csu-line: #e5e7eb;\r\n      --csu-accent: #2563eb;\r\n      --csu-accent-2: #0f766e;\r\n\r\n      color: var(--csu-text);\r\n      background: var(--csu-bg);\r\n      font-family: ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Noto Sans TC\",\r\n        \"PingFang TC\", \"Microsoft JhengHei\", Arial, sans-serif;\r\n      line-height: 1.7;\r\n    }\r\n\r\n    .csu-credits-page * { box-sizing: border-box; }\r\n    .csu-credits-page a { color: var(--csu-accent); text-decoration: none; }\r\n    .csu-credits-page a:hover { text-decoration: underline; }\r\n    .csu-credits-page p { margin: 0 0 12px; color: var(--csu-muted); }\r\n    .csu-credits-page h1, .csu-credits-page h2, .csu-credits-page h3 { margin: 0 0 12px; line-height: 1.25; color: var(--csu-text); }\r\n    .csu-credits-page h1 { font-size: 28px; letter-spacing: 0.2px; }\r\n    .csu-credits-page h2 { font-size: 20px; margin-top: 8px; }\r\n    .csu-credits-page h3 { font-size: 16px; margin-top: 2px; }\r\n\r\n    .csu-credits-page .container {\r\n      max-width: 1080px;\r\n      margin: 0 auto;\r\n      padding: 28px 16px 56px;\r\n    }\r\n\r\n    .csu-credits-page .hero {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 18px;\r\n      padding: 22px 18px;\r\n      background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\r\n      box-shadow: 0 10px 26px rgba(17, 24, 39, 0.06);\r\n    }\r\n\r\n    /* Top image */\r\n    .csu-credits-page .hero-media {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 16px;\r\n      overflow: hidden;\r\n      background: #ffffff;\r\n      box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);\r\n      margin-bottom: 16px;\r\n    }\r\n\r\n    .csu-credits-page .hero-media img {\r\n      display: block;\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n\r\n    .csu-credits-page .hero-top {\r\n      display: grid;\r\n      grid-template-columns: 1.2fr 0.8fr;\r\n      gap: 14px;\r\n      align-items: start;\r\n    }\r\n\r\n    .csu-credits-page .subheadline {\r\n      margin: 6px 0 0;\r\n      color: var(--csu-text);\r\n      font-weight: 650;\r\n      letter-spacing: 0.2px;\r\n    }\r\n\r\n    .csu-credits-page .tagline {\r\n      margin: 6px 0 0;\r\n      color: var(--csu-muted);\r\n      font-size: 14px;\r\n    }\r\n\r\n    .csu-credits-page .badge-row {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 8px;\r\n      margin: 10px 0 0;\r\n    }\r\n\r\n    .csu-credits-page .badge {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      padding: 6px 10px;\r\n      border-radius: 999px;\r\n      border: 1px solid var(--csu-line);\r\n      background: #ffffff;\r\n      color: var(--csu-muted);\r\n      font-size: 12.5px;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    .csu-credits-page .badge strong { color: var(--csu-text); font-weight: 650; }\r\n\r\n    .csu-credits-page .hero-side {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 14px;\r\n      padding: 14px 14px 12px;\r\n      background: var(--csu-surface-2);\r\n    }\r\n\r\n    .csu-credits-page .meta {\r\n      display: grid;\r\n      gap: 10px;\r\n      margin-top: 6px;\r\n    }\r\n\r\n    .csu-credits-page .meta-item {\r\n      display: grid;\r\n      gap: 2px;\r\n      padding: 10px 12px;\r\n      border-radius: 12px;\r\n      border: 1px solid var(--csu-line);\r\n      background: #ffffff;\r\n    }\r\n\r\n    .csu-credits-page .meta-label { font-size: 12px; color: var(--csu-muted); }\r\n    .csu-credits-page .meta-value { font-size: 14px; color: var(--csu-text); font-weight: 650; }\r\n\r\n    .csu-credits-page .grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr;\r\n      gap: 14px;\r\n      margin-top: 14px;\r\n    }\r\n\r\n    .csu-credits-page .section {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 16px;\r\n      background: #ffffff;\r\n      padding: 18px 16px;\r\n      box-shadow: 0 8px 20px rgba(17, 24, 39, 0.05);\r\n    }\r\n\r\n    .csu-credits-page .section-head {\r\n      display: flex;\r\n      align-items: baseline;\r\n      justify-content: space-between;\r\n      gap: 10px;\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .csu-credits-page .section-head .hint {\r\n      font-size: 12.5px;\r\n      color: var(--csu-muted);\r\n      border: 1px dashed #d1d5db;\r\n      padding: 6px 10px;\r\n      border-radius: 10px;\r\n      background: #fafafa;\r\n    }\r\n\r\n    .csu-credits-page .divider {\r\n      height: 1px;\r\n      background: var(--csu-line);\r\n      margin: 16px 0;\r\n    }\r\n\r\n    .csu-credits-page .table-wrap {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 14px;\r\n      overflow: hidden;\r\n      background: #ffffff;\r\n    }\r\n\r\n    .csu-credits-page table {\r\n      width: 100%;\r\n      border-collapse: collapse;\r\n      font-size: 13.5px;\r\n    }\r\n\r\n    .csu-credits-page thead th {\r\n      text-align: left;\r\n      padding: 12px 12px;\r\n      background: #f9fafb;\r\n      border-bottom: 1px solid var(--csu-line);\r\n      color: var(--csu-text);\r\n      font-weight: 650;\r\n      vertical-align: bottom;\r\n    }\r\n\r\n    .csu-credits-page tbody td {\r\n      padding: 12px 12px;\r\n      border-bottom: 1px solid var(--csu-line);\r\n      color: var(--csu-muted);\r\n      vertical-align: top;\r\n    }\r\n\r\n    .csu-credits-page tbody tr:last-child td { border-bottom: none; }\r\n\r\n    .csu-credits-page .pill {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      padding: 4px 10px;\r\n      border-radius: 999px;\r\n      border: 1px solid #dbeafe;\r\n      background: #eff6ff;\r\n      color: #1d4ed8;\r\n      font-size: 12px;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    /* =========================\r\n       各科課表：逐列呈現\r\n       ========================= */\r\n    .csu-credits-page .schedule-list {\r\n      display: grid;\r\n      gap: 10px;\r\n      margin-top: 10px;\r\n    }\r\n\r\n    .csu-credits-page .schedule-row {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 14px;\r\n      background: #ffffff;\r\n      padding: 12px 12px;\r\n    }\r\n\r\n    .csu-credits-page .schedule-head {\r\n      display: flex;\r\n      align-items: flex-start;\r\n      justify-content: space-between;\r\n      gap: 10px;\r\n      margin-bottom: 8px;\r\n    }\r\n\r\n    /* Slightly more space between course code pill and the English course name */\r\n    .csu-credits-page .schedule-head .pill { margin-bottom: 8px; }\r\n\r\n    .csu-credits-page .schedule-title {\r\n      margin: 0;\r\n      font-size: 15px;\r\n      color: var(--csu-text);\r\n      font-weight: 750;\r\n      line-height: 1.25;\r\n    }\r\n\r\n    .csu-credits-page .nowrap { white-space: nowrap; }\r\n\r\n    .csu-credits-page .kv {\r\n      display: grid;\r\n      grid-template-columns: 240px 1fr;\r\n      gap: 10px;\r\n      padding: 7px 0;\r\n      border-top: 1px solid var(--csu-line);\r\n    }\r\n\r\n    .csu-credits-page .kv:first-of-type { border-top: none; padding-top: 0; }\r\n    .csu-credits-page .k { color: #6b7280; font-size: 12px; margin: 0; }\r\n    .csu-credits-page .v { color: var(--csu-text); font-size: 13px; margin: 0; }\r\n\r\n    .csu-credits-page .scope-list {\r\n      margin: 6px 0 0;\r\n      padding-left: 18px;\r\n      color: var(--csu-muted);\r\n      font-size: 13px;\r\n    }\r\n    .csu-credits-page .scope-list li { margin: 6px 0; }\r\n\r\n    /* =========================\r\n       教學範圍：字級/層級更和諧（不動內容）\r\n       ========================= */\r\n    .csu-credits-page .teaching-scope {\r\n      font-size: 12.5px;\r\n      line-height: 1.75;\r\n      color: var(--csu-muted);\r\n    }\r\n\r\n    .csu-credits-page .teaching-scope p {\r\n      margin: 0 0 6px;\r\n      color: inherit;\r\n    }\r\n\r\n    .csu-credits-page .teaching-scope p:nth-child(odd) { color: #374151; }\r\n    .csu-credits-page .teaching-scope p:nth-child(even) { color: #4b5563; }\r\n    .csu-credits-page .teaching-scope p:nth-child(3) { margin-top: 8px; }\r\n    .csu-credits-page .teaching-scope p:nth-child(5) { margin-top: 8px; }\r\n    .csu-credits-page .teaching-scope p:last-child { margin-bottom: 0; }\r\n\r\n    /* =========================\r\n       評量方式 / 期末考試 / 選課身份 / 學分費用：直接顯示（不需點開）\r\n       ========================= */\r\n    .csu-credits-page .info-grid--four {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 12px;\r\n      margin-top: 10px;\r\n    }\r\n\r\n    .csu-credits-page .info-box {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 14px;\r\n      background: #ffffff;\r\n      padding: 12px 12px;\r\n    }\r\n\r\n    .csu-credits-page .info-box h3 {\r\n      margin: 0 0 8px;\r\n      font-size: 15px;\r\n      font-weight: 750;\r\n      color: var(--csu-text);\r\n    }\r\n\r\n    .csu-credits-page .mini {\r\n      font-size: 12.5px;\r\n      color: #6b7280;\r\n      margin: 0;\r\n    }\r\n\r\n    .csu-credits-page .bullets {\r\n      margin: 8px 0 0;\r\n      padding-left: 18px;\r\n      color: var(--csu-muted);\r\n      font-size: 13px;\r\n    }\r\n    .csu-credits-page .bullets li { margin: 6px 0; }\r\n\r\n    .csu-credits-page .badge-strong {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      padding: 4px 10px;\r\n      border-radius: 999px;\r\n      border: 1px solid #ccfbf1;\r\n      background: #f0fdfa;\r\n      color: var(--csu-accent-2);\r\n      font-size: 12px;\r\n      white-space: nowrap;\r\n      margin-left: 8px;\r\n    }\r\n\r\n    /* =========================\r\n       Call To Action (placed at the end)\r\n       ========================= */\r\n    .csu-credits-page .cta {\r\n      border: 1px solid var(--csu-line);\r\n      border-radius: 16px;\r\n      background: #f9fafb;\r\n      padding: 16px 14px;\r\n    }\r\n\r\n    .csu-credits-page .cta-head {\r\n      display: flex;\r\n      align-items: baseline;\r\n      justify-content: space-between;\r\n      gap: 10px;\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .csu-credits-page .cta-title {\r\n      margin: 0;\r\n      font-size: 18px;\r\n      font-weight: 800;\r\n      color: var(--csu-text);\r\n      line-height: 1.2;\r\n    }\r\n\r\n    .csu-credits-page .cta-sub {\r\n      margin: 0;\r\n      color: var(--csu-muted);\r\n      font-size: 13px;\r\n    }\r\n\r\n    .csu-credits-page .cta-sub a {\r\n      color: var(--csu-accent);\r\n      text-decoration: underline;\r\n      text-underline-offset: 3px;\r\n    }\r\n\r\n    .csu-credits-page .cta-sub a:hover {\r\n      color: #1d4ed8;\r\n      text-decoration-thickness: 2px;\r\n    }\r\n\r\n    .csu-credits-page .cta-actions {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 10px;\r\n      margin-top: 10px;\r\n    }\r\n\r\n    .csu-credits-page .btn {\r\n      display: inline-flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 10px;\r\n      width: 100%;\r\n      padding: 12px 12px;\r\n      border-radius: 14px;\r\n      border: 1px solid var(--csu-line);\r\n      background: #ffffff;\r\n      color: var(--csu-text);\r\n      font-weight: 800;\r\n      font-size: 14px;\r\n      text-decoration: none;\r\n      transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;\r\n    }\r\n\r\n    .csu-credits-page .btn:hover {\r\n      text-decoration: none;\r\n      transform: translateY(-1px);\r\n      background: #f9fafb;\r\n      border-color: #d1d5db;\r\n    }\r\n\r\n    .csu-credits-page .btn-primary {\r\n      background: var(--csu-accent);\r\n      border-color: var(--csu-accent);\r\n      color: #ffffff;\r\n    }\r\n\r\n    .csu-credits-page .btn-primary:hover {\r\n      background: #1d4ed8;\r\n      border-color: #1d4ed8;\r\n    }\r\n\r\n    .csu-credits-page .btn-secondary {\r\n      background: #ffffff;\r\n      border-color: #c7d2fe;\r\n      color: #1e3a8a;\r\n    }\r\n\r\n    .csu-credits-page .btn-secondary:hover {\r\n      background: #eef2ff;\r\n      border-color: #a5b4fc;\r\n    }\r\n\r\n    .csu-credits-page .btn-note {\r\n      margin-top: 10px;\r\n      font-size: 12.5px;\r\n      color: #6b7280;\r\n      line-height: 1.6;\r\n    }\r\n\r\n    /* =========================\r\n       RWD\r\n       ========================= */\r\n    @media (max-width: 920px) {\r\n      .csu-credits-page .hero-top { grid-template-columns: 1fr; }\r\n      .csu-credits-page .section-head { flex-direction: column; align-items: flex-start; }\r\n      .csu-credits-page h1 { font-size: 24px; }\r\n      .csu-credits-page .kv { grid-template-columns: 1fr; }\r\n      .csu-credits-page .info-grid--four { grid-template-columns: 1fr; }\r\n      .csu-credits-page .cta-actions { grid-template-columns: 1fr; }\r\n      .csu-credits-page .schedule-head .pill { margin-bottom: 10px; }\r\n    }\r\n\r\n    @media (max-width: 520px) {\r\n      .csu-credits-page .container { padding: 18px 12px 44px; }\r\n      .csu-credits-page .hero { padding: 18px 14px; }\r\n      .csu-credits-page .section { padding: 16px 14px; }\r\n      .csu-credits-page table { font-size: 13px; }\r\n      .csu-credits-page thead th, .csu-credits-page tbody td { padding: 10px 10px; }\r\n      .csu-credits-page .badge { font-size: 12px; }\r\n      .csu-credits-page .teaching-scope { font-size: 12.5px; }\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
